var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.29289,2.292893C8.105360000000001,2.105357,7.851,2,7.58579,2L3,2C2.447715,2,2,2.447715,2,3L2,10L3,10L3,3L7.58579,3L8.58579,4L13,4L13,13L9,13L9,14L13,14C13.5523,14,14,13.5523,14,13L14,4C14,3.44772,13.5523,3,13,3L9,3L8.29289,2.292893ZM4,5L12,5L12,6L4,6L4,5Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.28288,12.079365912475586L5.3535900000000005,10.150075912475586L4.64648,10.857182912475587L5.79297,12.003595912475586L2,12.003595912475586L2,13.003595912475586L5.7930399999999995,13.003595912475586L4.64648,14.150075912475586L5.3535900000000005,14.857185912475586L7.28288,12.927895912475586L7.35231,12.844795912475586C7.5143,12.610955912475585,7.49116,12.287645912475586,7.28288,12.079365912475586Z",
    fillRule: "evenodd",
    fill: "#222222",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.f08cedd0fc6ebf31613b2a8e054d13f9.svg";
export { ForwardRef as ReactComponent };